<template>
  <v-app>
    <v-main  class="pt-0">

      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; " :flat='true'>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-fab-transition>
              <v-btn
                color="#185ba6"
                fab
                elevation="6"
                bottom
                right
                v-bind="attrs"
                v-on="on"
                @click="make_mail_to()"
                style="top: 0; right:0;   position: absolute;    margin: 32px 32px 0 0;"
              >
                <v-icon>
                  mdi-email-fast
                </v-icon>
              </v-btn>
            </v-fab-transition>
          </template>
          <span>Напишите нам, если возникли проблемы</span>
        </v-tooltip>

        <div v-if="!loading && (reg_count == 0)">
          <p v-if="can_reg && !wait_reg" style="color: red; font-size: 16px;"><b>Вы еще НЕ зарегистрированы на Форум. Нажмите на кнопку ниже</b></p>
          <p v-if="!can_reg" style="color: red; font-size: 16px;"><b>Вы НЕ зарегистрированы на Форум. Регистрация уже завершена</b></p>
          <p v-if="wait_reg" style="color: red; font-size: 16px;"><b>Регистрация на форум еще не открыта</b></p>
        </div>

        <div v-if="reg_count > 0">
          <div v-for="reg_record in user_registrations" :key="reg_record.id">
            <v-card  class="main-container pa-3" style="margin-right: 75px !important; margin-bottom: 0px !important">

              <div v-if="reg_record.is_rejected" class="date-interval d-flex">
                <p style="color: red; font-size: 16px; margin-top:16px; margin-right: 10px;"><b>Приносим извинения, но ваша заявка отменена модератором</b></p>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="red darken-1"
                      @click="cancel_reg_dialog = true, reg_id = reg_record.id">
                      mdi-close-circle-outline
                      </v-icon>
                  </template>
                  <span>отменить регистрацию</span>
                </v-tooltip>
              </div>

              <div v-else>
                <div class="date-interval d-flex">
                  <p style="color: green; font-size: 16px; margin-top:16px; margin-right: 10px;"><b>Вы зарегистрированы на Форум</b></p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="cancel_reg_dialog = true, reg_id = reg_record.id">
                        mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <span>отменить регистрацию</span>
                  </v-tooltip>
                </div>
                <div class="date-interval d-flex">
                  <p v-if="reg_record.is_confirm == true" style="color: green; font-size: 16px; margin-top:0px; margin-right: 10px;"><b>Вы подтвердили участие в Форуме</b></p>
                </div>

                <v-row v-if="can_make_invite">
                  <div class="pl-2 content-personal__header d-flex justify-space-between align-start">
                    <v-chip
                      class="mr-2 ml-2"
                      dark
                      outlined
                      label
                      style="margin-bottom:20px;"
                      @click="make_invite({type: 'guest', id: reg_record.id})"
                      color="#ff810a">
                      <v-icon left>mdi-check-decagram</v-icon>
                      Скачать приглашение слушателя
                    </v-chip>
                  </div>                  
                </v-row>

                <v-row>
                  <v-col cols="3" style="text-align: right;padding-top: 22px;">
                    <p style="font-size: 16px;"><b>Мои доклады: </b></p>
                  </v-col>
                  <v-col cols="9">
                    <div v-if="can_add_speech && !can_speach_reg">
                      <v-chip
                        class="mr-2 ml-2 mt-2"
                        dark
                        outlined
                        label
                        style="margin-bottom:20px;"
                        color="#ff810a">
                        Регистрация докладчиком c {{ end_reg_speach_date.split('-').reverse().join('.') }} недоступна
                      </v-chip>
                    </div>
                    <!-- <div v-if="!can_add_speech && can_reg && !wait_reg">
                      <v-chip
                        class="mr-2 ml-2 mt-2"
                        dark
                        outlined
                        label
                        style="margin-bottom:20px;"
                        color="#ff810a">
                        Регистрация докладчиком откроется позднее
                      </v-chip>
                    </div> -->
                    <div v-if="can_add_speech && can_speach_reg">
                      <v-chip
                        class="mr-2 ml-2 mt-2"
                        dark
                        outlined
                        label
                        style="margin-bottom:20px;"
                        @click="add_reg_dialog = true"
                        color="#ff810a">
                        <v-icon left>mdi-plus</v-icon>
                        Добавить устное или стендовое выступление
                      </v-chip>
                    </div>

                    <div v-for="sp_record in speech_regs" :key="sp_record.id" class="mb-8">
                      <v-card  class="main-container pa-3" style="margin-right: 75px !important; margin-bottom: 0px !important">

                        <div v-if="sp_record.is_rejected">
                          <div>
                            <div class="d-flex">
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Приносим извинения, но ваша заявка отклонена </b></p>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="cancel_sp_reg_dialog = true, sp_reg_id = sp_record.id">
                                    mdi-close-circle-outline
                                    </v-icon>
                                </template>
                                <span>отменить выступление</span>
                              </v-tooltip>
                              <br>
                            </div>
                            <div v-if="sp_record.type > 1">
                              <p style="margin-bottom: 0px; font-size: 16px;" ><b>Секция: </b> {{ section_descr(sp_record.section_choice_id) }}</p>
                              <p style="font-size: 16px;"><b>Название доклада: </b> {{ sp_record.comments.length > 0 ? sp_record.comments : 'Не указано при регистрации!'}}</p>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="sp_record.confirm_type == 1">
                            <div class="d-flex">
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Вы отказались от участия со стендовым докладом</b></p>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="cancel_sp_reg_dialog = true, sp_reg_id = sp_record.id">
                                    mdi-close-circle-outline
                                    </v-icon>
                                </template>
                                <span>отменить выступление</span>
                              </v-tooltip>
                              <br>
                            </div>
                            <div v-if="sp_record.type > 1">
                              <p style="margin-bottom: 0px; font-size: 16px;" ><b>Секция: </b> {{ section_descr(sp_record.section_choice_id) }}</p>
                              <p style="font-size: 16px;"><b>Название доклада: </b> {{ sp_record.comments.length > 0 ? sp_record.comments : 'Не указано при регистрации!'}}</p>
                            </div>
                          </div>
                          <div v-if="sp_record.confirm_type > 1">
                            <div class="d-flex">
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Подтвержденный формат участия: </b> {{ sp_record.confirm_type == 2 ? 'Участник с устным докладом' : 'Участник со стендовым докладом' }}</p>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="cancel_sp_reg_dialog = true, sp_reg_id = sp_record.id">
                                    mdi-close-circle-outline
                                    </v-icon>
                                </template>
                                <span>отменить выступление</span>
                              </v-tooltip>
                            </div>
                            <div v-if="sp_record.confirm_type > 1">
                              <p style="font-size: 16px;  margin-right: 30px;"><b>Дата выступления: </b> {{ (sp_record.org_comment && sp_record.org_comment.length > 0) ? sp_record.org_comment : 'нет информации'}}</p>
                              <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(sp_record.section_confirm_id) }}</p>
                              <p style="font-size: 16px;"><b>Название доклада: </b> {{ sp_record.comments.length > 0 ? sp_record.comments : 'Не указано при регистрации!'}}</p>
                            </div>
                          </div>
                          <div v-if="sp_record.confirm_type == 0">
                            <div class="d-flex">
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Формат участия: </b> {{ sp_record.type == 1 ? 'Слушатель' : (sp_record.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом') }}</p>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="cancel_sp_reg_dialog = true, sp_reg_id = sp_record.id">
                                    mdi-close-circle-outline
                                    </v-icon>
                                </template>
                                <span>отменить выступление</span>
                              </v-tooltip>
                              <br>
                            </div>
                            <div v-if="sp_record.type > 1">
                              <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 16px;"> ожидайте подтверждения участия модератором </p>
                              <p style="margin-bottom: 0px; font-size: 16px;" ><b>Секция: </b> {{ section_descr(sp_record.section_choice_id) }}</p>
                              <p style="font-size: 16px;"><b>Название доклада: </b> {{ sp_record.comments.length > 0 ? sp_record.comments : 'Не указано при регистрации!'}}</p>
                            </div>
                          </div>


                          <div class="content-personal__header d-flex justify-space-between align-start" v-if="sp_record.is_confirm == false && sp_record.confirm_type > 1">
                            <v-chip
                              class="mr-2 ml-2"
                              dark
                              outlined
                              label
                              style="margin-bottom:20px;"
                              @click="current_sp_reg = sp_record, current_confirm_type=sp_record.confirm_type, confirm_reg_dialog = true"
                              color="#ff810a">
                              <v-icon left>mdi-check-decagram</v-icon>
                                Подтвердить участие в Курчатовском геномном форуме
                            </v-chip>
                          </div>

                          <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_upload_thesis && sp_record && !sp_record.thesis_id && (sp_record.confirm_type > 1 || (sp_record.confirm_type == 0 && sp_record.type > 1))">
                            <v-chip
                              class="mr-2 ml-2"
                              dark
                              outlined
                              label
                              style="margin-bottom:20px;"
                              @click="current_user_registration_id = sp_record.id; upload_thesis_dialog = true"
                              color="#4dbee1">
                              <v-icon left>mdi-file-plus-outline</v-icon>
                                Загрузить тезисы
                            </v-chip>
                          </div>
                          <div class="content-personal__header d-flex align-start" v-if="sp_record && sp_record.thesis_id > 0">
                            <v-chip
                              class="mr-2 ml-2"
                              dark
                              outlined
                              label
                              style="margin-bottom:20px;"
                              @click="show_thesis(sp_record.thesis_id)"
                              color="#4dbee1">
                              <v-icon left>mdi-file-check-outline</v-icon>
                              Мои тезисы
                            </v-chip>
                            <v-tooltip right  v-if="can_upload_thesis">
                              <template v-slot:activator="{ on, attrs }" class="pt-3">
                                  <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="delete_thesis_dialog = true; deleted_thesis_id = sp_record.thesis_id; deleted_thesis_reg_id = sp_record.id">
                                    mdi-close-circle-outline
                                  </v-icon>
                              </template>
                              <span>удалить тезисы</span>
                            </v-tooltip>
                          </div>

                          <div class="content-personal__header d-flex justify-space-between align-start" v-if="sp_record && (sp_record.confirm_type > 1 || (sp_record.confirm_type == 0 && sp_record.type > 1)) && !sp_record.exp_file_id">
                            <v-chip
                              class="mr-2 ml-2"
                              dark
                              outlined
                              label
                              style="margin-bottom:20px;"
                              @click="upload_file_dialog = true, file = '', file_type = 'exp_file', reg_id = sp_record.id"
                              color="#4dbee1">
                              <v-icon left>mdi-file-plus-outline</v-icon>
                                Загрузить экспертное заключение
                            </v-chip>
                          </div>

                          <div class="pl-4" v-if="sp_record && sp_record.exp_file_id > 0 && (sp_record.confirm_type > 1 || (sp_record.confirm_type == 0 && sp_record.type > 1))">
                            <template>
                                <v-row>
                                  <v-icon left>mdi-file</v-icon>
                                  <p style="margin-bottom: 0px;">{{ sp_record.exp_file }}</p>
                                </v-row>
                                <v-row>
                                  <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Экспертное заключение'" x-small inline>
                                    <p style="margin-bottom: 0px;"></p>
                                  </v-badge>
                                  <v-btn @click="openFile(sp_record.exp_file)" icon>
                                    <v-icon color="grey lighten-1">mdi-download</v-icon>
                                  </v-btn>
                                  <v-btn @click="deleteFile(sp_record.id, 'del_exp_file')" icon>
                                    <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                                  </v-btn>
                                </v-row>
                            </template>

                          </div>

                          <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="sp_record.confirm_type > 1"> -->
                          <div class="content-personal__header d-flex justify-space-between align-start" v-if="sp_record.confirm_type > 1 && sp_record.is_confirm == true && can_make_invite">
                            <v-chip
                              class="mr-2 ml-2"
                              dark
                              outlined
                              label
                              style="margin-bottom:20px;"
                              @click="make_invite({type: 'speech', id: sp_record.id})"
                              color="#ff810a">
                              <v-icon left>mdi-check-decagram</v-icon>
                              Скачать приглашение
                            </v-chip>
                          </div>

                          <!-- <v-card  class="main-container pa-3 ma-2" color="#ff8e8e" max-width="430px" style="text-align: center;" v-if="sp_record.type > 1 && sp_record.is_confirm == false && sp_record.confirm_type == 0">
                            <b style="color:black; text-align: center; font-size: 16px;"> После подтверждения модератором формата участия Вам будет доступна возможность скачать приглашение докладчика </b>
                          </v-card> -->
                        </div>

                      </v-card>
                    </div>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="3" style="text-align: right;padding-top: 22px;">
                    <p style="font-size: 16px;"><b>Школы: </b></p>
                  </v-col>
                  <v-col cols="9">
                    <div v-if="!can_add_school && !school_reg">
                      <v-chip
                        class="mr-2 ml-2 mt-2"
                        dark
                        outlined
                        label
                        style="margin-bottom:20px;"
                        color="#ff810a">
                        Регистрация на программы доп.образования c {{ end_reg_school_date.split('-').reverse().join('.') }} недоступна
                      </v-chip>
                    </div>

                    <div v-if="can_add_school && !school_reg">
                      <v-chip
                        class="mr-2 ml-2 mt-2"
                        dark
                        outlined
                        label
                        style="margin-bottom:20px;"
                        @click="add_school_dialog = true"
                        color="#ff810a">
                        <v-icon left>mdi-plus</v-icon>
                        Зарегистрироваться на программу доп.образования 
                      </v-chip>
                    </div>

                    <div v-if="school_reg">
                      <v-card  class="main-container pa-3" style="margin-right: 75px !important; margin-bottom: 0px !important">

                        <div v-if="school_reg.is_confirm && !school_reg.is_rejected">
                          <v-row class="ma-0">
                            <div class="d-flex">
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Поздравляем! Ваше участие в программе ДПО подверждено. </b></p>
                              <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ school_types[school_reg.type].name }}</p>
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red darken-1"
                                    @click="cancel_school_dialog = true, school_reg_id = school_reg.id">
                                    mdi-close-circle-outline
                                    </v-icon>
                                </template>
                                <span>отменить выступление</span>
                              </v-tooltip>
                            </div>
                          </v-row>
                          
                          <v-row>
                            <div class="content-personal__header d-flex justify-space-between align-start" v-if="school_reg.file_id && can_make_invite">
                              <v-chip
                                class="mr-2 ml-2"
                                dark
                                outlined
                                label
                                style="margin-bottom:20px;"
                                @click="make_invite({type: 'school', id: school_reg.id})"
                                color="#ff810a">
                                <v-icon left>mdi-check-decagram</v-icon>
                                Скачать приглашение
                              </v-chip>
                            </div>
                          </v-row>
                          <v-row v-if="!school_reg.file_id" class="ma-0 mt-4">
                            <p class="ma-0" style="font-size: 16px;">Пожалуйста скачайте, заполните и подпишите <b class="file-link" :style="{color: $mainColor}" @click="get_quest(school_reg.id)">Анкету</b></p>
                          </v-row>
                          <v-row v-if="!school_reg.file_id" class="ma-0">
                            <p class="ma-0" style="font-size: 16px;">Подгрузите отсканированную копию, а оригинал возьмите с собой</p>
                          </v-row>
                          <v-row v-if="!school_reg.file_id" class="ma-0">
                            <p class="ma-0" style="font-size: 16px;">Вы сможете скачать приглашение после загрузки анкеты</p>
                          </v-row>

                          <v-row class="ma-0">
                            <div class="content-personal__header d-flex justify-space-between align-start" v-if="!school_reg.file_id">
                              <v-chip
                                class="mr-2 ml-2"
                                dark
                                outlined
                                label
                                style="margin-bottom:20px;"
                                @click="upload_file_dialog = true, file = '', file_type = 'questionary_file', reg_id = school_reg.id"
                                color="#4dbee1">
                                <v-icon left>mdi-file-plus-outline</v-icon>
                                  подгрузить анкету
                              </v-chip>
                            </div>

                          </v-row>

                          <div class="pl-4 pt-4 pb-4" v-if="school_reg.file_id > 0">
                            <template>
                                <v-row>
                                  <v-icon left>mdi-file</v-icon>
                                  <p style="margin-bottom: 0px;">{{ school_reg.file }}</p>
                                </v-row>
                                <v-row>
                                  <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Анкета'" x-small inline>
                                    <p style="margin-bottom: 0px;"></p>
                                  </v-badge>
                                  <v-btn @click="openFile(school_reg.file)" icon>
                                    <v-icon color="grey lighten-1">mdi-download</v-icon>
                                  </v-btn>
                                  <v-btn @click="deleteFile(school_reg.id, 'del_questionary_file')" icon>
                                    <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                                  </v-btn>
                                </v-row>
                            </template>

                          </div>

      
                        </div>

                        <div v-if="!school_reg.is_confirm && school_reg.is_rejected">
                          <div class="d-flex">
                            <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Вы подали заявку на программу ДПО: </b></p>
                            <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ school_types[school_reg.type].name }}</p>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  color="red darken-1"
                                  @click="cancel_school_dialog = true, school_reg_id = school_reg.id">
                                  mdi-close-circle-outline
                                  </v-icon>
                              </template>
                              <span>отменить заявку</span>
                            </v-tooltip>
                            <br>
                          </div>
                          <v-card  class="main-container pa-3 ma-2" color="#ff8e8e" max-width="430px" style="text-align: center;">
                            <b style="color:black; text-align: center; font-size: 16px;"> Приносим извинения, но ваша заявка на участие в программе ДПО отклонена. </b>
                          </v-card>
                        </div>
                        
                        <div v-if="!school_reg.is_confirm && !school_reg.is_rejected">
                          <div class="d-flex">
                            <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Вы подали заявку на программу ДПО: </b></p>
                            <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ school_types[school_reg.type].name }}</p>
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  color="red darken-1"
                                  @click="cancel_school_dialog = true, school_reg_id = school_reg.id">
                                  mdi-close-circle-outline
                                  </v-icon>
                              </template>
                              <span>отменить заявку</span>
                            </v-tooltip>
                            <br>
                          </div>
                          <div>
                            <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 16px;"> Ожидайте подтверждения участия модератором </p>
                          </div>

                          <div>
                            <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 16px;"> Решение будет направлено на e-mail и отображено в личном кабинете </p>
                          </div>
                        </div>

                        <template v-if="school_reg && school_reg.org_comment && school_reg.org_comment.length > 0">
                          <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Комментарий орг.комитета: </b>  {{ school_reg.org_comment }} </p>
                        </template>
                        
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="3" style="text-align: right;padding-top: 22px;">
                    <p style="font-size: 16px;"><b>Планирую участвовать в качестве слушателя: </b></p>
                  </v-col>
                  <v-col cols="9">
                    <p v-for="rec in selected_listen_sections" style="font-size: 16px;  margin-left: 30px;">  {{ ' - ' }} {{ section_descr(rec) }}</p>
                  </v-col>
                </v-row>
                
              </div>
            </v-card>
          </div>
        </div>

        <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && !wait_reg && !loading && (reg_count == 0)">
          <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="margin-bottom:20px;"
            @click="registration_dialog = true"
            color="#ff810a">
            <v-icon left>mdi-check-decagram</v-icon>
              Зарегистрироваться на Курчатовский геномный форум
          </v-chip>
        </div>


        <v-card  class="main-container pa-3 mt-4" style="margin-right: 75px !important; margin-bottom: 0px !important">
          <p style="color: green; font-size: 16px; margin-top:16px; margin-right: 10px;"><b>Персональные данные</b></p>

          <personal-data-base/>
        </v-card>

      </v-card>
    </v-main>

    <v-dialog v-model="add_reg_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Зарегистрировать выступление
        </v-card-title>

        <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="user_type"
              :items="user_types"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <v-text-field
            v-model="dialog_comment"
            outlined
            required
            name="input-7-4"
            label="Название доклада"
          ></v-text-field>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="section_choice"
              :items="user_type == 2 ? speech_sections : stend_sections"
              item-text="name"
              item-value="id"
              outlined
              chips
              label="Выберите секцию"
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="add_one_reg()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_school_dialog" persistent max-width="60%">
      <v-card>
        <v-card-title class="headline">Подать заявку на обучение по программам ДПО
        </v-card-title>

        <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="school_type"
              :items="school_types"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-textarea v-if="school_type > 0"
          outlined
          :maxlength="3500"
          counter
          rows="10"
          :error="text_len_error"
          v-model="school_motivation"
          label="Напишите краткое мотивационное письмо (мин.: 500 знаков)"
          class="ml-6 mr-6"
        ></v-textarea>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_school_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="add_school_reg()">{{"Отправить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registration_dialog" persistent width="80%" max-width="1200px">
      <v-card class="pl-2 pr-2">
        <v-card-title class="headline">Зарегистрироваться на мероприятие
        </v-card-title>
        <!-- <v-card-text>Формат участия 
        </v-card-text> -->
        <v-row class="ma-0" v-if="GETTERS_SECTIONS.length > 0">
          <!-- <v-col cols="12" lg="5">
            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">Выберите формат участия:</b>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="user_type">
                  <v-radio
                    v-for="n in user_types"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <b style="font-size: 14px; font-style: italic;">Выберите сессию для выступления:</b>
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="section_choice">
                  <v-radio
                    v-for="n in (user_type == 2 ? speech_sections : stend_sections)"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>

              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <v-text-field
                v-model="dialog_comment"
                outlined
                required
                name="input-7-4"
                label="Название доклада"
              ></v-text-field>
            </v-card-text>

          </v-col> -->
          <v-col cols="12" lg="12">
            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">На каких мероприятиях форума вы планируете присутствовать в качестве слушателя?</b>

              <v-row class="pt-8">
                <v-col cols="4" style="text-align: right;">
                  <p>1 день (09 ноября)</p>
                </v-col>
                <v-col cols="8">
                  <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 1 && section.is_active"
                    :key="section.id"
                    :disabled="!section.is_public"
                    v-model="selected_listen_sections"
                    :value="section.id"
                    style="margin-top: 0px !important; margin-left: 8px !important;"
                    :label="section.name"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="text-align: right;">
                  <p>2 день (10 ноября)</p>
                </v-col>
                <v-col cols="8">
                  <div v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 2 && section.is_active" :key="section.id">
                    <v-checkbox 
                      :disabled="!section.is_public"
                      v-model="selected_listen_sections"
                      :value="section.id"
                      style="margin-top: 0px !important; margin-left: 8px !important;"
                      :label="section.name"
                    ></v-checkbox>
                    <!-- <v-card-text v-if="need_proj_name"> -->
                      <!-- <v-text-field v-if="need_proj_name && section.id == session_young_id"
                        v-model="project_name"
                        outlined
                        required
                        name="input"
                        label="Название проекта"
                        class="pl-10"
                      ></v-text-field> -->
                    <!-- </v-card-text> -->

                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="global_registration()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_reg_dialog" persistent max-width="55%">
      <v-card>
        <v-card-title class="headline">Подтвердить участие в форуме
        </v-card-title>

        <v-card-text v-if="current_sp_reg">
          <div v-if="current_sp_reg.confirm_type > 1">
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Предлагаемый формат участия: </b> {{ current_sp_reg.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата выступления: </b> {{ (current_sp_reg.org_comment && current_sp_reg.org_comment.length > 0) ? current_sp_reg.org_comment : 'нет информации'}}</p>
          </div>

          <p style="margin-bottom: 0px; font-size: 16px;" v-if="current_sp_reg.type > 1"><b>Секция: </b> {{ section_descr(current_sp_reg.section_confirm_id) }}</p>
          <p style="margin-bottom: 0px; font-size: 16px;" v-if="current_sp_reg.type > 1"><b>Название доклада: </b> {{ current_sp_reg.comments.length > 0 ? current_sp_reg.comments : 'Не указано при регистрации!'}}</p>
        </v-card-text>

        <v-card-text v-if="current_sp_reg && current_sp_reg.confirm_type == 3 && current_sp_reg.type == 2">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="current_confirm_type"
              :items="user_types_poster"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text>
          <p>На каких мероприятиях форума вы планируете присутствовать в качестве слушателя?</p>

          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>1 день (09 ноября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 1 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.name"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>2 день (10 ноября)</p>
            </v-col>
            <v-col cols="8">
              <div v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 2 && section.is_active" :key="section.id">
                <v-checkbox 
                  :disabled="!section.is_public"
                  v-model="selected_listen_sections"
                  :value="section.id"
                  style="margin-top: 0px !important; margin-left: 8px !important;"
                  :label="section.name"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirm_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="confirm_reg()">{{"Подтвердить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_reg_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите отменить регистрацию на форум?
        </v-card-title>
        <!-- <v-card-text> -->
        <v-card-text v-if="!can_reg">
          С {{ end_reg_date.split('-').reverse().join('.') }} регистрация на форум закрыта. У вас не будет возможности зарегистрироваться заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancel_reg_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="cancel_reg()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_sp_reg_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите отменить заявку на выступление?
        </v-card-title>
        <!-- <v-card-text> -->
        <v-card-text v-if="!can_speach_reg">
          С {{ end_reg_speach_date.split('-').reverse().join('.') }} регистрация на форум закрыта. У вас не будет возможности зарегистрироваться заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancel_sp_reg_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="cancel_sp_reg()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_school_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите отменить заявку?
        </v-card-title>
        <!-- <v-card-text> -->
        <v-card-text v-if="!can_add_school">
          С {{ end_reg_school_date.split('-').reverse().join('.') }} регистрация на программы ДПО закрыта. У вас не будет возможности подать заявку заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancel_school_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="cancel_school_reg()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_thesis_dialog" persistent width="700px">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите удалить подгруженные тезисы?
        </v-card-title>
        <!-- <v-card-text> -->
        <v-card-text v-if="!can_upload_thesis">
          C {{ thesis_last_date.split('-').reverse().join('.') }} прием тезисов окончен. У вас не будет возможности подгрузить их заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="delete_thesis_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="delete_thesis()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_file_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title v-if="file_type == 'questionary_file'" class="headline"> Подгрузка анкеты
        </v-card-title>
        <v-card-title v-else class="headline">{{ file_type == 'thesis_file' ? 'Подгрузка тезисов' : 'Подгрузка экспертного заключения' }}
        </v-card-title>

        <v-card-text v-if="file_type == 'questionary_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: pdf)
        </v-card-text>
        <v-card-text v-if="file_type == 'thesis_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx)
        </v-card-text>
        <v-card-text v-if="file_type == 'thesis_pdf'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: pdf)
        </v-card-text>
        <v-card-text v-if="file_type == 'exp_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx, pdf)
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Добавить файл"
            color="#4dbee1"
            :success="loadedFile"
            :loading="loadedFile"
            prepend-icon="mdi-paperclip">
          </v-file-input>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="upload_file_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="upload_file()">{{"Загрузить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_thesis_dialog" persistent max-width="90%">
      <thesis-upload
        :current_user_registration_id="current_user_registration_id"
        @updateParent="update_parent($event)"
        @closeDialog="close_dialog($event)"
      />
    </v-dialog>

    <v-dialog v-model="thesis_show_dialog" max-width="50%">
      <thesis-show
        :thesis_data="thesis_data"
        @closeDialog="thesis_show_dialog=false"
      />
    </v-dialog>

  </v-app>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import personalDataBase from '../components/Common/PersonalDataBase.vue'
import thesisUpload from '../components/Common/ThesisUpload2.vue'
import thesisShow from '../components/Common/ThesisShow.vue'

export default {

  mounted() {
    if(localStorage.isLoggedIn === undefined){
      this.$router.push('/login')
      return
    }

    this.update_sections()
  },

  name: 'PersonalData',
  components: {
    personalDataBase,
    thesisUpload,
    thesisShow,
  },
  data: () => ({
    end_reg_date: '2026-10-31', // global 
    end_reg_school_date: '2026-10-27',
    end_reg_speach_date: '2026-10-06',
    thesis_last_date: '2026-10-06',

    start_reg_date: '2026-08-01',
    last_conf_date: '2026-11-10',
    
    can_upload_thesis: false,
    can_reg: false,
    can_add_speech: false,
    can_add_school: false,
    can_speach_reg: false,


    registration_dialog: false,
    reg_id: null,
    cancel_reg_dialog: false,
    cancel_sp_reg_dialog: false,
    confirm_reg_dialog: false,
    current_sp_reg: null,
    dialog_comment: '',
    user_registrations: [],
    user_registrations_list: [],
    upload_file_dialog: false,
    add_reg_dialog: false,
    user_type: 1,
    user_types: [
        {id: 1, name : 'Выберите тип'},
        {id: 2, name : 'Участник с устным докладом'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    current_confirm_type: 1,
    user_types_poster: [
        {id: 1, name : 'Слушатель (без доклада)'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],

    add_school_dialog: false,
    school_type: 0,
    school_types: [
        {id: 0, name : 'Выберите тип'},
        {id: 1, name : 'Современные биотехнологии: повышение производительности разработок и производств'},
        {id: 2, name : 'Особенности генетических исследований лабораторных приматов'},
      ],
    school_motivation: '',
    text_len_error: false,
    school_reg: null,
    school_reg_id: null,
    cancel_school_dialog: false,

    section: 0,
    section_choice: 0,
    section_types: [
        {id: 0, name : 'выберите секцию:'},
        // {id: 1, name : 'секция 1: "Перспективные синхротронные и нейтронные исследования"'},
        {id: 2, name : 'сессия 1: "«Актуальные исследования и разработки, выполняемые на источниках синхротронного излучения и нейтронов, а также комплексах ядерной медицины"'},
        {id: 3, name : 'сессия 2: "Концепция и научная программа синхротронно-лазерного комплекса «СИЛА»"'},
        {id: 4, name : 'Микросимпозиум 1: "Разработка научной программы развития нейтронных исследований в Российской Федерации"'},
        {id: 5, name : 'Микросимпозиум 2: "Научная программы проектов РИФ и ТНК «Зеленоград»"'},
      ],
    loadedFile: false,
    file: null,
    checkFile: false,
    file_id: null,
    file_type: '',

    title: 'This will be the title',
    loading: false,
    model: null,
    date: new Date().toISOString().substr(0, 10),
    edit: false,
    loaded: false,
    reg_count: 0,
    can_make_sert: false,
    can_make_invite: false,
    selected_listen_sections: [],
    active_sections: [],
    speech_sections : [],
    stend_sections: [],
    active_sections_list: {},
    need_proj_name: false,
    project_name: '',
    session_young_id: 15,
    current_user_registration_id: 0,
    upload_thesis_dialog: false,
    thesis_data: {},
    thesis_show_dialog: false,
    delete_thesis_dialog: false,
    deleted_thesis_id: null,
    deleted_thesis_reg_id: null,
    current_reg_id: null,

    speech_regs: [],
    sp_reg_id: null,

  }),

  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },

    GETTERS_SECTIONS(val) {
      this.update_sections()
    },

    school_motivation(val){
      if(this.school_motivation.length < 500)
        this.text_len_error = true
      else
        this.text_len_error = false
    },

    // selected_listen_sections(arr){
    //   var find = false
    //   this.selected_listen_sections.forEach((item) => {
    //     if(item == this.session_young_id)
    //       find = true
    //   })
    //   this.need_proj_name = find
    // },
  },

  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'logged',
      'GET_USER_SCHOOL_REG',
      'GET_USER_GLOBAL_REG',
      'GET_USER_SPEECH_REG',
      'MAKE_REGISTRATION',
      'MAKE_SPEECH_REGISTRATION',
      'MAKE_GLOBAL_REGISTRATION',
      'MAKE_SCHOOL_REGISTRATION',
      'FILE_SEND',
      'ADD_THESIS_FILE',
      'CHANGE_REGISTRATION',
      'CHANGE_REGISTRATION_GLOBAL',
      'CHANGE_SP_REGISTRATION',
      'MAKE_INVITE',
      'MAKE_SERT',
      'DELETE_THESIS_REC',
      'LOAD_THESIS_REC',
      'QUESTIONARY_TO_DOCX',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),
    
    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });

        this.reload_reg_data()

        var curr_date = new Date().toISOString().substr(0, 10)
        this.can_reg = curr_date < this.end_reg_date
        this.can_make_invite = true

        this.wait_reg = curr_date < this.start_reg_date
        this.can_upload_thesis = curr_date < this.thesis_last_date
        this.can_make_sert = curr_date >= this.last_conf_date

        this.can_add_school = curr_date < this.end_reg_school_date
        this.can_speach_reg = curr_date < this.end_reg_speach_date


        // for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
        //   const element = this.GETTERS_CURRENT_USER.role[index];

        //   if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
        //     this.can_make_invite = true
        //   }
        // }  


        this.loading = false;

      } catch (ex) {
        console.log('ex ---> ', ex);
      }
    },

    make_mail_to(){
      window.open('mailto:forum@genrussia.ru', '_blank')

    },

    closeDialog(item){
      this.upload_thesis_dialog = false;
    },

    update_parent(item) {
      this.upload_thesis_dialog = false;
      if(item > 0){
        this.reload_reg_data();
      }
      // this.loadListProposals(this.status_id);
      // this.$emit('updateParent', item);
    },

    allowedDates(val){
      return (val > '2023-10-22' && val < '2023-10-29')
    },

    section_descr(id){
      if(!this.active_sections_list){
        setTimeout(() => {
          return this.section_descr(id)
        }, 500);

      }
      if(id > 0){
        if(!this.active_sections_list[id]){
          setTimeout(() => {
            return this.section_descr(id)
          }, 500);
        }
        else
          return this.active_sections_list[id].name
      }
      else
        return 'Не указано при регистрации!'
    },

    show_thesis(id){
      this.UPDATE_OVERLAY(true)
      this.LOAD_THESIS_REC(id)
      .then((res) => {
        this.thesis_data = res;
        this.thesis_show_dialog = true;
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });

    },

    delete_thesis(){
      this.UPDATE_OVERLAY(true)
      let dataUpdateStatus = {
        thesis_id: this.deleted_thesis_id,
        reg_id: this.deleted_thesis_reg_id
      };

      this.DELETE_THESIS_REC(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.reload_reg_data();
          this.delete_thesis_dialog = false
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });

    },


    upload_file() {
      this.file_id = null
      if(this.checkFile) {        
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);

        var file_type_id = 0
        if(this.file_type == 'thesis_pdf')
          file_type_id = 3
        else if (this.file_type == 'thesis_file')
          file_type_id = 4
        else if (this.file_type == 'exp_file')
          file_type_id = 5
        else if (this.file_type == 'questionary_file')
          file_type_id = 6
        files.append('type', file_type_id)



        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.file_id = res.data.id
            this.save_thesis_file()
          })
          .catch(() => this.loadedFile = false)
      }
      
    },

    save_thesis_file(){
      let dataUpdateStatus = {
        id: this.reg_id,
        file_id: this.file_id,
        file_type: this.file_type
      }

      this.UPDATE_OVERLAY(true)

      this.ADD_THESIS_FILE(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.upload_file_dialog = false;
            this.reload_reg_data();
            this.$messageHelper('Успешнo', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        })
      
    },

    openFile(fileName) {
      window.open(`https://genom.kcsni-service.ru/media/${fileName}`, '_blank')
    },

    deleteFile(id,type){
      let dataUpdateStatus = {
        id: id,
        type: type
      };

      this.change_sp_reg(dataUpdateStatus)
    },

    get_quest(id){
      this.UPDATE_OVERLAY(true)
      this.QUESTIONARY_TO_DOCX({id: id})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => this.UPDATE_OVERLAY(false));
    },

    add_one_reg(){

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        section_choice: this.section_choice,
        reg_id: this.current_reg_id
      };

      if(this.user_type < 2 || this.dialog_comment.length == 0 || this.section_choice == 0)
        this.$messageHelper('Заполните все поля', 'error', 3000);
      else{
        this.UPDATE_OVERLAY(true)
        this.MAKE_SPEECH_REGISTRATION(data)
          .then((res) => {
            if (!res.data.hasOwnProperty('error')) {
              this.add_reg_dialog = false;
              this.reload_reg_data();

              this.$messageHelper('Успешная регистрация', 'success', 3000);
            } else {
              this.$messageHelper(res.data.error, 'error', 3000);
            }
            this.UPDATE_OVERLAY(false)
          })
          .catch((e) => {
            console.log('eee', e);
            this.$messageHelper(e.message, 'error', 4000);
            this.UPDATE_OVERLAY(false)
          });
      }
    },

    add_school_reg(){
      var data = {
        type: this.school_type,
        reg_id: this.current_reg_id,
        school_motivation: this.school_motivation
      };

      if(this.school_motivation.length < 500 || this.school_type == 0)
        this.$messageHelper('Заполните все поля', 'error', 3000);
      else{
        this.UPDATE_OVERLAY(true)
        this.MAKE_SCHOOL_REGISTRATION(data)
          .then((res) => {
            if (!res.data.hasOwnProperty('error')) {
              this.add_school_dialog = false;
              this.reload_reg_data();

              this.$messageHelper('Успешная регистрация', 'success', 3000);
            } else {
              this.$messageHelper(res.data.error, 'error', 3000);
            }
            this.UPDATE_OVERLAY(false)
          })
          .catch((e) => {
            console.log('eee', e);
            this.$messageHelper(e.message, 'error', 4000);
            this.UPDATE_OVERLAY(false)
          });
      }
    },

    global_registration() {
      this.UPDATE_OVERLAY(true)

      var data = {
        selected_listen_sections: this.selected_listen_sections,
      };

      this.MAKE_GLOBAL_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    registration() {
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        section_choice: this.section_choice,
        one_more: false,
        selected_listen_sections: this.selected_listen_sections,
        project_name: null
      };

      if(this.need_proj_name){
        if(this.project_name.length == 0){
          this.$messageHelper('Укажите название проекта', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }
        else{
          data.project_name = this.project_name
        }
      }

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    change_reg_global(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_REGISTRATION_GLOBAL(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.confirm_reg_dialog = false;
          this.cancel_reg_dialog = false;
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    confirm_reg(){
        let dataUpdateStatus = {
          id: this.current_sp_reg.id,
          is_confirm: true,
          type: 'confirm_reg',
          selected_listen_sections: this.selected_listen_sections,
        };
        if(this.current_sp_reg.confirm_type == 3 && this.current_confirm_type == 1){
          dataUpdateStatus.cancel_poster = 1
        }
        else{
          dataUpdateStatus.cancel_poster = -1
        }

        this.change_sp_reg(dataUpdateStatus)
    },

    cancel_reg(){
        let dataUpdateStatus = {
          id: this.reg_id,
          is_active: true,
          type: 'cancel_reg'
        };

        this.change_reg_global(dataUpdateStatus)
    },


    cancel_sp_reg(){
        let dataUpdateStatus = {
          id: this.sp_reg_id,
          is_active: true,
          type: 'cancel_speech_reg'
        };

        this.change_sp_reg(dataUpdateStatus)
    },

    change_sp_reg(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_SP_REGISTRATION(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.cancel_sp_reg_dialog = false;
          this.cancel_school_dialog = false;
          this.confirm_reg_dialog = false;
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    cancel_school_reg(){
        let dataUpdateStatus = {
          id: this.school_reg_id,
          is_active: true,
          type: 'cancel_school_reg'
        };

        this.change_sp_reg(dataUpdateStatus)
    },    

    change_reg(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_REGISTRATION(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.confirm_reg_dialog = false;
          this.cancel_reg_dialog = false;
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_invite(data){
      this.UPDATE_OVERLAY(true)
      this.MAKE_INVITE(data)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_sert(){
      this.UPDATE_OVERLAY(true)

      this.MAKE_SERT(this.reg_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    validateFile(val) {
      const type = val.name.split('.').pop();
        
      if(val.size > 6291456){
        this.$messageHelper('Размер файла превышает 6 мб', 'error')
        this.checkFile = false
        this.file = null
      }
      else{
        if (this.file_type == 'thesis_file' && type !== 'doc' && type !== 'docx'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'thesis_pdf' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'exp_file' && type !== 'doc' && type !== 'docx' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else{
          this.checkFile = true
        }
      }

    },

    reload_reg_data(){
      this.school_reg = null

      this.GET_USER_GLOBAL_REG()
      .then((res) => {
        this.reg_count = res.length;
        this.selected_listen_sections = []
        if(res.length > 0){
          this.user_registrations = res
          this.current_reg_id = res[0].id
          this.user_registrations_list = []
          var ls = []
          this.project_name = res[0].project_name
          this.user_registrations.forEach((item) => {
            if(item.listen_sections !== null){
              ls = item.listen_sections.split(', ')
            }
            this.user_registrations_list[item.id] = item
          })
          ls.forEach((item) => {
            this.selected_listen_sections.push(parseInt(item))
          })

          this.can_add_speech = false

          this.GET_USER_SPEECH_REG({'reg_id' : this.current_reg_id})
          .then((data) => {
            this.speech_regs = data.speech_regs

            if(this.speech_regs.length < 3){
              this.can_add_speech = true
            }
          })

          this.GET_USER_SCHOOL_REG(this.current_reg_id)
          .then((data) => {
            if(data.length > 0){
              this.school_reg = data[0]
            }
          })

        }
        else{
          this.user_registrations = null
          this.user_registrations_list = []
        }

      })
    },

    update_sections(){
      this.active_sections = []

      this.GETTERS_SECTIONS.forEach((item) => {
        if(item.is_active && item.is_public){
          this.active_sections.push(item)
        }
        this.active_sections_list[item.id] = item
        if(item.is_active && item.can_reg_speach)
          this.speech_sections.push(item)
        if(item.is_active && item.can_reg_stend)
          this.stend_sections.push(item)
      })

      // setTimeout(() => {
      //   return this.uploadDataUser()
      // }, 5000);
        
      this.uploadDataUser()
    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_CURRENT_USER',
      'GETTERS_SECTIONS',
    ]),
  },
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  .file-link {
    cursor: pointer;
  }

  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
